import React from 'react'
import scs from "assets/images/im-success.gif";
import MainButton from 'components/MainButton';
import { useNavigate } from 'react-router-dom';


export default function Success() {
    const navigate = useNavigate();
    setTimeout(() => {
        navigate('/')
    }, 5000);
  return (
    <div className="flex flex-col items-center justify-center min-h-screen">
      <img src={scs} alt="success" width={300} height={300} />
      <h1 className='my-8 text-2xl font-semibold'>Proses pendaftaran berhasil!</h1>
      <MainButton label="Kembali untuk login" onClick={() => navigate("/")} />
    </div>
  );
}
